import { request } from "@/utils/request";

/**
 * 查询小程序公告
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/notice/select`,
    method: "POST",
    data,
  });
}


export function updateApi(data) {
  return request({
    url: `/admin/notice/update`,
    method: "POST",
    data,
  });
}

export function addApi(data) {
  return request({
    url: `/admin/notice/add`,
    method: "POST",
    data,
  });
}

export function deleteApi(data) {
  return request({
    url: `/admin/notice/delete`,
    method: "POST",
    data,
  });
}